<template>
  <aside v-if="exportState.status !== 'idle'" class="csv-export-notification" aria-live="polite" aria-atomic="true">
    <template v-if="exportState.status === 'running'">
      <strong>Exportando CSV</strong>
      <p>{{ exportState.completedPages }} de {{ exportState.totalPages }} páginas carregadas.</p>
      <progress :value="exportState.completedPages" :max="exportState.totalPages" aria-label="Progresso da exportação"></progress>
      <p>Você pode continuar usando a plataforma.</p>
    </template>
    <template v-else>
      <strong>{{ exportState.status === 'success' ? 'CSV pronto! Download iniciado.' : 'Falha na exportação' }}</strong>
      <p v-if="exportState.error">{{ exportState.error }}</p>
      <div class="csv-export-notification-actions">
        <button v-if="exportState.status === 'success'" type="button" @click="downloadCSV">Baixar novamente</button>
        <button type="button" @click="dismissCSVExport">Fechar</button>
      </div>
    </template>
  </aside>
</template>

<script>
import { csvExportState, downloadCSV, dismissCSVExport } from "@/services/cnpjCSVExport";

export default {
  name: "CSVExportNotification",
  setup() {
    return { exportState: csvExportState, downloadCSV, dismissCSVExport };
  },
};
</script>

<style scoped>
.csv-export-notification {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10000;
  width: min(360px, calc(100vw - 40px));
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 12px;
  background: #fff;
  color: #4d5163;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.csv-export-notification p {
  margin: 8px 0;
}

.csv-export-notification progress {
  width: 100%;
}

.csv-export-notification-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
}

.csv-export-notification button {
  width: auto;
  margin: 0;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  color: #4d5163;
  cursor: pointer;
}
</style>
